import { PromotionalCardProps } from '@interfaces/productGrid'
import React from 'react'

const PromotionalCard: React.FC<PromotionalCardProps> = ({
  heading,
  description,
  headingColor,
  descriptionColor,
  image,
  topBackground,
  bottomBackground,
  link,
}) => (
  <div
    style={{ backgroundImage: `url(${image.src})`, backgroundSize: 'cover', backgroundPosition: 'left center' }}
    className="flex flex-col justify-between rounded relative overflow-hidden"
  >
    <div
      className="h-1/5 py-2 px-4 flex items-start"
      style={{ background: `linear-gradient(to bottom, ${topBackground}, transparent)` }}
    >
      <h2 className="h2 font-bold italic" style={{ color: headingColor }}>
        {heading}
      </h2>
    </div>
    <div
      className="h-1/5 py-2 px-4 flex items-end"
      style={{ background: `linear-gradient(to top, ${bottomBackground}, transparent)` }}
    >
      <p className="util-lg-sm italic" style={{ color: descriptionColor }} dangerouslySetInnerHTML={{ __html: description }}></p>
    </div>
    {link && <a href={link} className="absolute inset-0 z-1"></a>}
  </div>
)

export default PromotionalCard
